

/**
 * Vuex.Store getters
 * @author LiQingSong
 */
const getters = {


  // token: (state) => state.user.token,
  // accessTokenProduct: (state) => state.user.accessTokenProduct,
  balance: (state) => state.user.balance,
  taskDetail: (state) => state.user.taskDetail,
  logo: (state) => state.user.logo,
  currentTab: (state) => state.user.currentTab,
  openTopUp: (state) => state.openTopUp,
  currentMenu: (state) => state.currentMenu,

  showInvite: (state) => state.showInvite,
  apolloConfig: (state) => state.apolloConfig, // 获取所有apollo配置
  getApolloConfig: (state) => (key) => state.apolloConfig[key], // 获取单个apollo配置
};
export default getters;
